<template>
    <div>
      <base-dialog v-model="$store.state.chat.showDialog.create" :title="modalTitle"
      :okBtnText="$t('create')" :okBtnVariant="'success'" :cancelBtnText="$t('back')" :cancelBtnVariant="'secondary'" :keepOpened="keepOpenedModal"
      :okFn="() => { createChat() }" :cancelFn="() => { resetValues() }">
        <template>
          <div v-if="showOptionsBlock">
            <search-blocks-professional @showInterconsultationModal="checkIfInterconsultation"></search-blocks-professional>
          </div>
          <div v-else>
            <base-select class="mt-2" searchable clearable avoidDefaultSort :disabled="isUserSelectorDisabled" :loading="createChatUser.loading" :options="createChatUser.options" valueProp="id" label="name" v-model="createChatUser.value" @search="isChatWithProf ? searchProfByName($event) : searchPatientByName($event)" :placeholder="isChatWithProf ? $t('chats.select-prof') : $t('chats.select-patient')">
              <template #option="data">
                <div>
                  <img class="photo-option" :src="getUserPhoto(createChatUser.options, data.option.value)" alt=""/> <span>{{data.option.label}}</span>
                </div>
              </template>
            </base-select>
            <base-select class="mt-2" v-if="interconsultation" searchable clearable avoidDefaultSort :loading="interconsultationPatient.loading" :options="interconsultationPatient.options" valueProp="id" label="name" v-model="interconsultationPatient.value" @search="searchPatientByName($event)" :placeholder="$t('chats.select-patient')">
              <template #option="data">
                <div>
                  <img class="photo-option" :src="getUserPhoto(interconsultationPatient.options, data.option.value)" alt=""/> <span>{{data.option.label}}</span>
                </div>
              </template>
            </base-select>
            <div class="mt-4">
              <base-input v-if="interconsultation" v-model="subject" :placeholder="$t('chats.subject')" :maxlength="50"></base-input>
              <base-textarea :rows="1" :max-rows="5" v-model="newMessage" :placeholder="$t('chats.new-message')"></base-textarea>
              <upload-file-group-form v-model="fileObjects"></upload-file-group-form>
            </div>
          </div>
        </template>
      </base-dialog>
    </div>
</template>
<script>

import BaseDialog from '@/components/base/BaseDialog'
import SearchRepository from '@/repositories/SearchRepository'
import ProfessionalRepository from '@/repositories/ProfessionalRepository'
import UploadFileGroupForm from '@/components/base/forms/UploadFileGroupForm'
import BaseTextarea from '@/components/base/forms/BaseTextarea.vue'
import SearchBlocksProfessional from '@/components/webapp/professional/interconsultations/SearchBlocksProfessional.vue'
import ChatRepository from '@/repositories/ChatRepository'
import { PROFESSIONAL_ROLE } from '@/constants/roles'
import { getFilesAndLinks } from '@/helpers/file.helpers'

export default {
    components: {
        BaseDialog,
        BaseTextarea,
        UploadFileGroupForm,
        SearchBlocksProfessional
    },
    props: {
        isChatWithProf: {
            type: Boolean,
            default: true
        },
        selectedProf: {
          type: Object,
          required: false
        },
        openedFromOuicare: {
          type: Boolean,
          default: false
        }
    },
    data () {
        return {
            interconsultationPatient: {
                loading: false,
                options: [],
                value: null
            },
            createChatUser: {
                loading: false,
                options: [],
                value: null
            },
            fileObjects: [],
            subject: null,
            newMessage: null,
            interconsultation: false,
            profChatTypeSelected: false,
            firstTimeOpen: true
        }
    },
    watch: {
      'selectedProf' (value) {
        this.setPickedUserData(value)
      }
    },
    created () {
      if (this.openedFromOuicare) {
        if (this.$route.query.professionalId) {
          SearchRepository.getProfById(this.$route.query.professionalId).then((response) => {
            this.setPickedUserData(response.data)
          })
        } else if (this.$route.query.patientId) {
          SearchRepository.getPatientById(this.$route.query.patientId).then((response) => {
            this.setPickedUserData(response.data)
          })
        }
      }
    },
    methods: {
        setPickedUserData (userInfo) {
          this.$set(this.createChatUser, 'options', [userInfo])
          this.$set(this.createChatUser, 'value', userInfo.id)
          this.checkIfInterconsultation(userInfo.interconsultation)
        },
        searchPatientByName (name) {
            if (name && name.length >= 3) {
                ProfessionalRepository.getProfPatients(name).then((response) => {
                if (this.isChatWithProf) {
                    this.interconsultationPatient.options = response.data
                } else {
                    this.createChatUser.options = response.data
                }
                })
            }
        },
        searchProfByName (name) {
            if (name && name.length >= 3) {
                SearchRepository.getProfsByName(name).then(response => {
                this.createChatUser.options = response.data
                })
            }
        },
        getUserPhoto (options, id) {
            let user = options.find(item => item.id === id)
            return user.photo || this.defaultImg
        },
        checkIfInterconsultation (isInterconsultation) {
          this.interconsultation = isInterconsultation
          this.profChatTypeSelected = true
        },
        async createChat () {
          if (!this.createChatUser.value) {
            this.$store.dispatch('showDangerAlert', this.$t('chats.user-not-selected'))
          } else if (!this.newMessage) {
            this.$store.dispatch('showDangerAlert', this.$t('chats.message-not-written'))
          } else {
            var filesAndLinks = await getFilesAndLinks(this.fileObjects)
            var chatObject = {
              reason: this.newMessage,
              interconsultation: this.interconsultation ? {
                patientId: this.interconsultationPatient.value,
                facilityId: null,
                subject: this.subject
              } : null,
              files: filesAndLinks.files,
              links: filesAndLinks.links
            }
            if (this.isChatWithProf) chatObject.askedProfessional = this.createChatUser.value
            else chatObject.askedPatient = this.createChatUser.value
            ChatRepository.createChat(chatObject).then((response) => {
                if (!response.data) {
                  throw response.response.data
                }
                if (this.$route.path.includes('/professional-network')) {
                  this.$router.push({name: 'ProfessionalChat', params: { role: PROFESSIONAL_ROLE }})
                } else {
                  this.$emit('createAdministrativeChat', response.data)
                }
                this.$store.dispatch('showSuccessAlert', this.$t('chats.create-prof-chat-success'))
                this.resetValues()
            }).catch((error) => {
              var msgAppend = error.includes('already-active-chat') ? ` - ${this.$t('chats.already-active-chat')}` : ''
              this.$store.dispatch('showDangerAlert', `${this.$t('chats.create-prof-chat-fail')}${msgAppend}`)
            })
          }
        },
        resetValues () {
          this.interconsultationPatient = {
            loading: false,
            options: [],
            value: null
          }
          this.createChatUser = {
            loading: false,
            options: [],
            value: null
          }
          this.fileObjects = []
          this.subject = null
          this.newMessage = null
          this.interconsultation = false
          this.profChatTypeSelected = false
          this.firstTimeOpen = false
        }
    },
    computed: {
        defaultImg () {
            return this.isChatWithProf ? '/static-appopensalud/img/icons/morillas-svg-icons/primary/doctor.svg' : '/static-appopensalud/img/icons/morillas-svg-icons/primary/user.svg'
        },
        modalTitle () {
          return `${this.$t('chats.administrative-chat')} - ${this.isChatWithProf ? this.$t('professional') : this.$t('patient')}`
        },
        isUserSelectorDisabled () {
          return this.createChatUser.value !== null && this.modalOpenedFromOutsideButton
        },
        showOptionsBlock () {
          return !this.modalOpenedFromOutsideButton && this.isChatWithProf && !this.profChatTypeSelected && !this.firstTimeOpen
        },
        keepOpenedModal () {
          return !this.modalOpenedFromOutsideButton && this.isChatWithProf && this.profChatTypeSelected && !this.firstTimeOpen
        },
        modalOpenedFromOutsideButton () {
          return !!this.selectedProf || this.openedFromOuicare
        }
    }
}
</script>
<style lang="scss" scoped>
.photo-option{
  border-radius: 50%;
  padding: 0;
  width: 30px;
  height: 30px;
}
div.form-group {
  margin-bottom: 0.75rem !important;
}
/deep/ .service-prof-type {
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/views/chat-interconsultations/AdministrativeChatModal.vue